export const DiscountCodes = {
  JLR_STOCK: 'jlrStock',
};
